var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "price-filter" }, [
    _c("div", { staticClass: "title-container" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Price")]),
      _vm._v(" "),
      _c("p", { staticClass: "icon", on: { click: _vm.collapse } }, [
        _vm._v(_vm._s(_vm.plusIcon))
      ])
    ]),
    _vm._v(" "),
    !_vm.collapsed
      ? _c(
          "div",
          { staticClass: "price-slide-container" },
          [
            _c("div", { staticClass: "price-container" }, [
              _c("span", [_vm._v("Min: $" + _vm._s(_vm.rangePrice.min))]),
              _vm._v(" "),
              _c("span", [_vm._v("Max: $" + _vm._s(_vm.rangePrice.max))])
            ]),
            _vm._v(" "),
            _c("MultiRangeSlider", {
              attrs: {
                baseClassName: "range-slider",
                min: _vm.prices.min,
                max: _vm.prices.max,
                step: 1,
                ruler: false,
                label: false,
                minValue: _vm.rangePrice.min,
                maxValue: _vm.rangePrice.max
              },
              on: { input: _vm.UpdateValues }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }